import { useContext } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import profile from "../assets/images/icons/mobile-profile.svg";
import search from "../assets/images/icons/mobile-search-icon.svg";
import share from "../assets/images/icons/link-icon.svg";
import myBox from "../assets/images/icons/my-box.svg";
import SharedProfileModal from "./SharedProfileModal";
import { MainContext } from "../utils/MainContext";
import { LoginContext } from "../utils/Auth";
import { useTranslation } from "react-i18next";

const width = window.innerWidth;

const MobileNavBar = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const { t } = useTranslation();
  const { user } = useContext(LoginContext);
  const {
    setSharedProfileModal,
    sharedProfileModal,
    setDashboardPage,
    dashboardPage,
    setMySelfProfilView,
  } = useContext(MainContext);

  return (
    <div className="mobileNavBar">
      <nav className="navigation">
        <ul className="list">
          <li className="item">
            <NavLink
              to="/dashboard"
              onClick={() => {
                setDashboardPage("boxes");
                setMySelfProfilView(false);
                setSharedProfileModal(false);
              }}
            >
              <div className="icon">
                <img src={myBox} alt="box-icon" />
              </div>
              <span
                className={`itemName ${dashboardPage === "boxes" && "blue"}`}
              >
                {t("mobileNavBar.box")}
              </span>
            </NavLink>
          </li>
          <li className="item">
            <NavLink
              to="/search"
              onClick={() => {
                setMySelfProfilView(false);
                setSharedProfileModal(false);
              }}
            >
              <div className="icon">
                <img src={search} alt="search-icon" />
              </div>
              <span
                className={`itemName ${
                  !sharedProfileModal && pathname.includes("search") && "blue"
                }`}
              >
                {t("mobileNavBar.search")}
              </span>
            </NavLink>
          </li>
          <li
            className="item"
            onClick={() => {
              if (width > 768) {
                setSharedProfileModal(!sharedProfileModal);
              } else {
                navigate("/share-profile");
              }
            }}
          >
            <div className="icon">
              <img src={share} alt="share-icon" />
            </div>
            <span
              className={`itemName ${pathname.includes("/share-profile") ? "share" : ""}`}
            >
              {t("mobileNavBar.share")}
            </span>
          </li>
          <li className="item">
            <NavLink
              to={`/profile/${user?.profile?.username}`}
              onClick={() => {
                setSharedProfileModal(false);
              }}
            >
              <div className="icon">
                <img src={profile} alt="profile-icon" />
              </div>
              <span
                className={`itemName ${
                  (!sharedProfileModal && pathname.includes("profile")) ||
                  dashboardPage === "upgrade-pack"
                    ? "blue"
                    : ""
                }`}
              >
                {t("mobileNavBar.profile")}
              </span>
            </NavLink>
          </li>
        </ul>
      </nav>
      <SharedProfileModal data={user} isLocal={false} onClose={() => {}} />
    </div>
  );
};

export default MobileNavBar;
